import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { FaTrash } from 'react-icons/fa';
import { SaveSearchButton } from './AssignedUserReport/AssignedUserReport';
import SaveSearchesModal from './SaveSearchesModal';

interface Proptypes {
  formatFilters: () => any[];
  reportId: number;
  handleFilter: (id: number, filters: any[]) => void;
  padding?: number;
}

const SaveSearchesDropdown = (props: Proptypes) => {
  const [usedFilter, setUsedFilter] = useState({ id: null });
  const [openSaveSearchModal, setOpenSaveSearchModal] = useState(false);
  const [usersFilters, setUsersFilters] = useState([]);
  const [rerender, setRerender] = useState(true);

  const getFilters = async () => {
    const { data } = await axios.get(`/api/reports/getusersfilters/${props.reportId}`);
    setUsersFilters(data);
    setUsedFilter(data[0]);
  };

  const deleteFilter = async (filterId: number, e: React.MouseEvent) => {
    console.log('deleting filter', filterId);
    e.stopPropagation();
    e.preventDefault();

    await axios.delete(`/api/reports/deleteUserFilter/${filterId}`);
    setRerender(true);
    if (usedFilter?.id === filterId) {
      setUsedFilter({ id: null });
    }
  };

  const CustomOption = (props: any) => {
    return (
      <components.Option {...props}>
        <div
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
        >
          <span>{props.label}</span>
          <FaTrash
            onClick={e => deleteFilter(props.data.value, e)}
            style={{ cursor: 'pointer', color: '#dc3545', marginLeft: 10 }}
          />
        </div>
      </components.Option>
    );
  };

  useEffect(() => {
    if (rerender) {
      getFilters();
      setRerender(false);
    }
  }, [rerender]);
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ marginRight: 8, marginTop: 7 }}>
        <Select
          options={usersFilters.map(uf => {
            return { label: uf.filterName, value: uf.id };
          })}
          onChange={selections => {
            setUsedFilter(selections?.value);
            props.handleFilter(selections?.value, usersFilters);
          }}
          value={usedFilter?.id}
          placeholder={'Select a saved search'}
          isClearable={true}
          styles={{ control: styles => ({ ...styles, height: 48, width: 300 }) }}
          components={{ Option: CustomOption }}
        />
      </div>
      {/* @ts-ignore */}
      <SaveSearchButton padding={props.padding} onClick={() => setOpenSaveSearchModal(true)}>
        Save Search
      </SaveSearchButton>
      {openSaveSearchModal && (
        <SaveSearchesModal
          onClose={() => setOpenSaveSearchModal(false)}
          filters={props.formatFilters()}
          reportId={props.reportId}
          rerender={() => setRerender(true)}
        />
      )}
    </div>
  );
};
export default SaveSearchesDropdown;
